// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".device-layout[data-v-24f8dc48]{position:relative}.device-layout[data-v-24f8dc48] >.loading-block{z-index:1000;position:fixed}.device-layout[data-v-24f8dc48] >.loading-block:before{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
